// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'employment-histories',
        component: () =>
            import('@/pages/[organisation]/hr/team-member-employment-histories/employment-histories.vue'),
        name: 'human-resource.team-member-employment-histories.search-employment-histories',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.employment.view-employment-histories',
        },
    },
    {
        path: 'employment-histories/:employmentHistoryId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-employment-histories" */ '@/pages/[organisation]/hr/team-member-employment-histories/employment-history/[id]/edit.vue'),
        name: 'human-resource.team-member-employment-histories.update-employment-history',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.employment.update-team-member-employment-history',
        },
    },
];
